import {
  TabsContent,
  TabsList,
  Tabs as TabsRoot,
  TabsTrigger,
} from '@ria-client/tw-shadcn/components/tabs';
import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

type TabNode = NodeProps<{ title?: string; children?: StructuredContent | StructuredContent[] }>;

// Port of VE structured-content Tabs; styled after the Medicare Part B overview tabs.
export function Tabs({ props }: NodeProps<{ defaultTabIndex?: number; tabs?: TabNode[] }>) {
  const tabs = (props.tabs ?? []).flatMap((tab, index) =>
    tab.props.title?.trim() ? [{ tab, index }] : [],
  );
  if (!tabs.length) return null;

  const requested = props.defaultTabIndex ?? 0;
  const defaultIndex = tabs.some(({ index }) => index === requested) ? requested : tabs[0].index;

  return (
    <TabsRoot defaultValue={String(defaultIndex)}>
      <TabsList className="border-[var(--content-neutral-light)]">
        {tabs.map(({ tab, index }) => (
          <TabsTrigger
            className="h-auto border-0 px-4 py-2 font-medium tracking-[0.09rem] data-[state=active]:bg-transparent data-[state=active]:text-primary"
            key={index}
            value={String(index)}
          >
            {tab.props.title}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map(({ tab, index }) => (
        <TabsContent className="pt-2" key={index} value={String(index)}>
          <StructuredContentRenderer doc={tab.props.children} />
        </TabsContent>
      ))}
    </TabsRoot>
  );
}
